if (!customElements.get('special-coupon-list')) {
  class SpecialCouponList extends HTMLElement {
    constructor() {
      super();
      this.designWidth = Number(this.getAttribute('data-design-width')) || 444;
      this.baseFontSize = Number(this.getAttribute('data-base-font-size')) || 20;
      this.columns = Number(this.getAttribute('data-columns')) || 3;
      this.gap = Number(this.getAttribute('data-gap')) || 19;
      this.lastWidth = 0;
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    onResize(entries) {
      const entry = entries && entries[0];
      if (!entry) return;
      const width = entry.contentRect.width;
      if (!width || Math.abs(width - this.lastWidth) < 0.5) return;
      this.lastWidth = width;
      const cardWidth = (width - this.gap * (this.columns - 1)) / this.columns;
      if (cardWidth <= 0) return;
      this.style.fontSize = `${(cardWidth / this.designWidth) * this.baseFontSize}px`;
    }
  }

  customElements.define('special-coupon-list', SpecialCouponList);
}
